/** Browser-safe invite URLs; fragments never enter HTTP request paths/referrers. */
export function takeInviteToken(location,history) {
  const params=new URLSearchParams((location.hash??'').replace(/^#/,''));
  if(!params.has('invite'))return null;
  const token=params.get('invite'),url=new URL(location.href);params.delete('invite');url.hash=params.toString();
  history.replaceState(null,'',url.href);
  return /^[-_a-zA-Z0-9]{43}$/.test(token??'')?token:'';
}
export function makeInviteLink(origin,token) {
  if(!/^[-_a-zA-Z0-9]{43}$/.test(token??''))throw Error('Invalid invitation.');
  const url=new URL('/',origin);url.hash=new URLSearchParams({invite:token}).toString();return url.href;
}
export async function shareInviteLink(url,{navigator=globalThis.navigator,copy=false}={}) {
  if(!copy&&typeof navigator.share==='function') {
    try{await navigator.share({title:'Join me in Valoria',text:'Come join me nearby in Valoria.',url});return 'shared';}
    catch(error){if(error.name==='AbortError')return 'cancelled';}
  }
  if(navigator.clipboard?.writeText){try{await navigator.clipboard.writeText(url);return 'copied';}catch{}}
  return 'manual';
}
